module.exports = __webpack_public_path__ + "files/81485255a1951a3f1e224bde09c2b0e9.woff2";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/exo2-bolditalic-webfont.woff2
// module id = 824
// module chunks = 60